export default __webpack_public_path__ + "static/media/paycheck.c40efce8.svg";